var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9647 7.21044L24.7887 10.0331L21.9647 7.21044ZM23.7807 4.72377L16.1447 12.3598C15.7501 12.7538 15.4811 13.2557 15.3713 13.8024L14.666 17.3331L18.1967 16.6264C18.7433 16.5171 19.2447 16.2491 19.6393 15.8544L27.2754 8.21844C27.5048 7.98897 27.6868 7.71656 27.811 7.41675C27.9352 7.11694 27.9991 6.79561 27.9991 6.4711C27.9991 6.14659 27.9352 5.82526 27.811 5.52545C27.6868 5.22564 27.5048 4.95323 27.2754 4.72377C27.0459 4.49431 26.7735 4.31229 26.4737 4.1881C26.1739 4.06392 25.8525 4 25.528 4C25.2035 4 24.8822 4.06392 24.5824 4.1881C24.2826 4.31229 24.0101 4.49431 23.7807 4.72377V4.72377Z",
    stroke: "white",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.333 19.9993V23.9993C25.333 24.7066 25.0521 25.3849 24.552 25.885C24.0519 26.3851 23.3736 26.666 22.6663 26.666H7.99967C7.29243 26.666 6.61415 26.3851 6.11406 25.885C5.61396 25.3849 5.33301 24.7066 5.33301 23.9993V9.33268C5.33301 8.62544 5.61396 7.94716 6.11406 7.44706C6.61415 6.94697 7.29243 6.66602 7.99967 6.66602H11.9997",
    stroke: "white",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditWhite);
export default __webpack_public_path__ + "static/media/editWhite.999c44e0bd06bcb1ad55257df7398abe.svg";
export { ForwardRef as ReactComponent };